// extracted by mini-css-extract-plugin
module.exports = {"container":"EvergreenShopBanner_container__968ho"};